.cue-cards-container {
    width: 250px;
    flex-shrink: 0;
    padding: 16px 16px 0 0;
}
